<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">数据中心</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">业务统计</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-statistics">
            <a-tabs default-active-key="1" @change="callback">
                <a-tab-pane key="1" tab="按所属人统计"></a-tab-pane>
                <a-tab-pane key="2" tab="按创建时间统计"></a-tab-pane>
            </a-tabs>

            <div class="top-search">
                <a-row type="flex">
                    <a-col><label for="">创建时间：</label></a-col>
                    <a-col>
                        <div class="select-date-custom">
                            <a-input class="search-date" v-model="time" @click="showdate">
                                <a-tooltip slot="suffix" title="Extra information">
                                    <div class="date-icon"></div>
                                </a-tooltip>
                            </a-input>
                            <span class="select-date-modal" v-if="dateshow">
                                <div class="date-modal">
                                    <div class="time-modal">
                                        <div class="time-system">
                                            <div class="select-item" @click="selectdate2(i,item)" :class="{clickdate:i==currentdate}" v-for="(item,i) in datelist2" :key="i">{{item}}</div>
                                        </div>
                                        <div class="time-custom">
                                            <span class="time-system-text">自定义</span>
                                            <div class="time-select-index-hide">
                                                <a-date-picker format="YYYY-MM-DD" @change="dateChange2"/>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </a-col>
                </a-row>

                <!-- <a-row  type="flex">
                    <a-col><label for="">部门：</label></a-col>
                    <a-col>
                        <a-select default-value="lucy" style="width: 120px" @change="handleChange">
                            <a-select-option value="jack">
                                Jack
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">员工：</label></a-col>
                    <a-col>
                        <a-select default-value="1" style="width: 120px" @change="handleChange">
                            <a-select-option value="1">
                                呼入
                            </a-select-option>
                            <a-select-option value="2">
                                呼出
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row> -->
            </div>

            <div class="tj-charts">
                <a-tabs default-active-key="1" >
                    <a-tab-pane key="1" tab="接听率"></a-tab-pane>
                    <a-tab-pane key="2" tab="呼出次数"></a-tab-pane>
                    <a-tab-pane key="3" tab="通话人数"></a-tab-pane>
                    <a-tab-pane key="4" tab="通话时长"></a-tab-pane>
                    <a-tab-pane key="5" tab="平均通话时长"></a-tab-pane>
                </a-tabs>

                <div class="chart-content">
                    <div :style="{display:chart1}" id="weightChart" style="width: 100%;height:394px;"></div>
                    <div :style="{display:chart2}" id="weightChart2" style="width: 100%;height:394px;"></div>
                </div>
            </div>

            
            <div class="table-content">
                <div class="table-top-info">
                    <a-button icon="upload">导出</a-button>
                    <div>线索数：{{total.totaldata}}</div>
                    <div>客户数：{{total.totalbussness}}</div>
                    <div>商机数：{{total.totaldata}}</div>
                    <div>总数：{{total.total}}</div>
                </div>

                <a-table :columns="columns" :data-source="data">
                    <a slot="name" slot-scope="text">{{ text }}</a>
                </a-table>
            </div>
        </div>
    </div>
</template>

<script>
const columns = [
  {
    title: '员工姓名',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '线索数',
    dataIndex: 'datanum',
    key: 'datanum',
  },
  {
    title: '客户数',
    dataIndex: 'kehunum',
    key: 'kehunum',
    ellipsis: true,
  },
  {
    title: '联系人数',
    dataIndex: 'contractnum',
    key: 'contractnum',
    ellipsis: true,
  },
  {
    title: '商机数',
    dataIndex: 'bussnessnum',
    key: 'bussnessnum',
    ellipsis: true,
  }
];


export default {
    data(){
        return{
            data:"",
            columns,
            echarts1:"",
            echarts2:"",
            total:"",
            datelist2:['今天','昨天','本周','上周','本月','上月'],
            currentdate:"",
            dateshow:false,
            time:"今天",
            chart1:'block',
            chart2:'none'
        }
    },
    mounted(){
        
        this.bystafftj()
    },
    methods:{

        // 日期选择
        handleChange(){

        },
        showdate(){
            this.dateshow=!this.dateshow
        },
        selectdate2(a,b){
            this.currentdate=a
            this.time=b
            this.dateshow=false
            this.bystafftj()
            this.bydatetj()
        },
        dateChange2(data,dateString){
            console.log(dateString)
            this.time=dateString
            this.dateshow=false
            this.bystafftj()
            this.bydatetj()
        },

        // 切换tab
        callback(key){
            if(key==1){
                this.bystafftj()
                this.chart1='block'
                this.chart2='none'
      
            }else if(key==2){
                this.chart2='block',
                this.chart1='none'
                this.bydatetj()
            }
        },
        
        bystafftj(){
            // 业务统计（人员）
            this.$axios.get('/api/workstatistic',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.time
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.data=res.data.data.list
                    this.total=res.data.data.statistic
                    this.echarts1=res.data.data.echarts
                    this.drawLine()
                }else{
                    this.$message.error(res.data.msg)
                }
            })
        },

        bydatetj(){
            // 业务统计（日期）
            this.$axios.get('/api/workstatisticbytime',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.time
                }
            }).then((res)=>{
                if(res.data.code==200){
                    // this.data=res.data.data.list
                    // this.total=res.data.data.statistic
                    this.echarts2=res.data.data.echarts
                    this.drawLine2()
                }else{
                    this.$message.error(res.data.msg)
                }
            })
        },

        drawLine(){
            var weightChart = this.$echarts.init(document.getElementById("weightChart"))
            weightChart.setOption({
                legend: {
                    y: 'bottom',    //延Y轴居中
                },
                tooltip: {},
                grid: {  
                    left: '1%',  
                    right: '4%', 
                    top:'10%', 
                    bottom: '10%',  
                    containLabel: true  
                },
                xAxis: {
                    type: 'category',
                    data:this.echarts1.xaixs
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.echarts1.yaixs,
                    type: 'bar',
                    barWidth: 40,
                    itemStyle: {
                    normal: {
            　　　　　　　　//这里是重点
                            color: function(params) {
                                var colorList = ['#5e83f9','#50e5cc', '#25c9fd', '#bd6ff2'];
                                return colorList[params.dataIndex]
                            }
                        }
                    }
                }]
            });
        },


        drawLine2(){
            var weightChart = this.$echarts.init(document.getElementById("weightChart2"))
            weightChart.setOption({
                legend: {
                    y: 'bottom',    //延Y轴居中
                    data: ['线索', '客户', '联系人', '商机']
                },
                tooltip: {},
                grid: {  
                    left: '1%',  
                    right: '4%', 
                    top:'10%', 
                    bottom: '10%',  
                    containLabel: true  
                },
                xAxis:[{
                    type: 'category',
                    data: this.echarts2.xaixs
                }],
                yAxis:[{
                    type: 'value'
                }],
                series: [
                    {type: 'bar',
                    itemStyle: {
                        normal: {
            　　　　　　　　//这里是重点
                            color: "#5e83f9"
                        }},
                        data: this.echarts2.yaixs.data
                    },
                    {type: 'bar',itemStyle: {
                        normal: {
            　　　　　　　　//这里是重点
                            color: "#50e5cc"
                        }},
                        data: this.echarts2.yaixs.kehu
                    },
                    {type: 'bar',itemStyle: {
                        normal: {
            　　　　　　　　//这里是重点
                            color: "#25c9fd"
                        }},
                        data: this.echarts2.yaixs.contract
                    },
                    {type: 'bar',itemStyle: {
                        normal: {
            　　　　　　　　//这里是重点
                            color: "#bd6ff2"
                        }},
                        data: this.echarts2.yaixs.bussness
                    },
                       
                ]
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/data/businesstj.vue